import React from 'react';
import ConfirmDeleteDialog from '../ConfirmDeleteDialog';
import MARRecordDialog from './MARRecordDialog';
import type { UseMarRecords } from './useMarRecords';

interface MarDialogsProps {
  patientId: string;
  visitId: string;
  mar: UseMarRecords;
}

/** Renders the MAR add/edit and delete-confirmation dialogs from hook state. */
const MarDialogs: React.FC<MarDialogsProps> = ({ patientId, visitId, mar }) => {
  const { recordDialog, deleteDialog } = mar;
  return (
    <>
      <MARRecordDialog
        open={recordDialog.open}
        onOpenChange={recordDialog.setOpen}
        patientId={patientId}
        visitId={visitId}
        medication={recordDialog.target}
        existing={recordDialog.editing}
        onSaved={recordDialog.onSaved}
      />
      <ConfirmDeleteDialog
        open={deleteDialog.pending !== null}
        onOpenChange={open => !open && deleteDialog.cancel()}
        title='Delete Administration Record'
        description='Are you sure you want to delete this administration record? This action cannot be undone.'
        onConfirm={deleteDialog.confirm}
        isDeleting={deleteDialog.isDeleting}
      />
    </>
  );
};

export default MarDialogs;
